const ATIVO_PRAZO = {
    VST: { id: 'VST', descricao: 'À Vista' },
    OPC: { id: 'OPC', descricao: 'Opção' },
    TER: { id: 'TER', descricao: 'Termo' },
    FUT: { id: 'FUT', descricao: 'Futuro' },
    SWP: { id: 'SWP', descricao: 'Swap' },
    EMP: { id: 'EMP', descricao: 'Empréstimo' },

    LEA: { id: 'LEA', descricao: 'Leasing/Arrendamento' },
    COR: { id: 'COR', descricao: 'Consórcio' },
    FIN: { id: 'FIN', descricao: 'Financiamento' },
    ROT: { id: 'ROT', descricao: 'Rotativo' },
    CIG: { id: 'CIG', descricao: 'Consignado' }
};

module.exports = ATIVO_PRAZO;

// 010 VISTA
// 012 EXERCÍCIO DE OPÇÕES DE COMPRA
// 013 EXERCÍCIO DE OPÇÕES DE VENDA
// 017 LEILÃO
// 020 FRACIONÁRIO
// 030 TERMO
// 050 FUTURO COM RETENÇÃO DE GANHO
// 060 FUTURO COM MOVIMENTAÇÃO CONTÍNUA 070 OPÇÕES DE COMPRA
// 080 OPÇÕES DE VENDA

// Enum DBCnsMercadoPrazo
//     Futuro = 1
//     Opcao = 2
//     aVista = 3
//     Termo = 4
//     Emprestimo = 5
//     Direito = 6
//     Recibo = 7
//     CoberturaMargem = 8
// End Enum
